var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8667 48C93.8667 73.3315 73.3315 93.8667 48 93.8667C22.6685 93.8667 2.13333 73.3315 2.13333 48C2.13333 22.6685 22.6685 2.13333 48 2.13333C73.3315 2.13333 93.8667 22.6685 93.8667 48Z",
    fill: "url(#paint0_linear_3_1246)",
    stroke: "url(#paint1_linear_3_1246)",
    strokeWidth: 4.26667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4857 16.0813C40.8742 16.6887 40.5449 16.969 40.2156 17.2026C38.8515 18.2772 37.111 18.8378 35.3705 18.7444C34.9471 18.7444 34.5238 18.6509 33.6771 18.5575C32.0777 18.3239 31.278 18.2304 30.5724 18.2304C27.5618 18.3706 24.9276 20.2861 23.8457 23.0893C23.6105 23.7434 23.4693 24.5377 23.1871 26.1262C23.046 26.9671 22.9519 27.3876 22.8578 27.8081C22.3874 29.49 21.3055 30.9384 19.8472 31.9195C19.518 32.1531 19.1416 32.34 18.389 32.7605C16.9308 33.508 16.2252 33.8818 15.6607 34.3022C13.3087 36.171 12.2738 39.2546 13.0735 42.1512C13.2616 42.8053 13.6379 43.5529 14.3435 45.0012C14.7199 45.7487 14.908 46.1692 15.0492 46.543C15.6607 48.1782 15.6607 49.9535 15.0492 51.5888C14.908 51.9625 14.7199 52.3363 14.3435 53.1305C13.6379 54.5789 13.2616 55.3264 13.0735 55.9805C12.2738 58.8771 13.2616 61.9607 15.6607 63.8295C16.2252 64.25 16.9308 64.6237 18.389 65.3713C19.1416 65.7917 19.518 65.9786 19.8472 66.2122C21.3055 67.1934 22.3404 68.6417 22.8578 70.3236C22.9519 70.6974 23.046 71.1646 23.1871 72.0056C23.4693 73.594 23.6105 74.3883 23.8457 75.0424C24.8805 77.8456 27.5618 79.7611 30.5724 79.9013C31.278 79.948 32.0777 79.8078 33.6771 79.5742C34.5238 79.4341 34.9471 79.3874 35.3705 79.3874C37.111 79.3406 38.8515 79.9013 40.2156 80.9291C40.5449 81.1627 40.8272 81.4898 41.4857 82.0504C42.6617 83.1717 43.2262 83.7324 43.8377 84.1061C46.3779 85.7413 49.6237 85.7413 52.1638 84.1061C52.7283 83.7324 53.3398 83.1717 54.5158 82.0504C55.1274 81.4431 55.4566 81.1627 55.7859 80.9291C57.1501 79.8546 58.8906 79.2939 60.6311 79.3874C61.0544 79.3874 61.4778 79.4808 62.3245 79.5742C63.9239 79.8078 64.7236 79.9013 65.4292 79.9013C68.4397 79.7611 71.074 77.8456 72.1559 75.0424C72.3911 74.3883 72.5322 73.594 72.8145 72.0056C72.9556 71.1646 73.0497 70.7441 73.1437 70.3236C73.6141 68.6417 74.6961 67.1934 76.1543 66.2122C76.4836 65.9786 76.8599 65.7917 77.6125 65.3713C79.0708 64.6237 79.7764 64.25 80.3409 63.8295C82.6929 61.9607 83.7278 58.8771 82.9281 55.9805C82.7399 55.3264 82.3636 54.5789 81.658 53.1305C81.2817 52.383 81.0935 51.9625 80.9524 51.5888C80.3409 49.9535 80.3409 48.1782 80.9524 46.543C81.0935 46.1692 81.2817 45.7954 81.658 45.0012C82.3636 43.5529 82.7399 42.8053 82.9281 42.1512C83.7278 39.2546 82.7399 36.171 80.3409 34.3022C79.7764 33.8818 79.0708 33.508 77.6125 32.7605C76.8599 32.34 76.4836 32.1531 76.1543 31.9195C74.6961 30.9384 73.6612 29.49 73.1437 27.8081C73.0497 27.4343 72.9556 26.9671 72.8145 26.1262C72.5322 24.5377 72.3911 23.7434 72.1559 23.0893C71.121 20.2861 68.4397 18.3706 65.4292 18.2304C64.7236 18.1837 63.9239 18.3239 62.3245 18.5575C61.4778 18.6976 61.0544 18.7444 60.6311 18.7444C58.8906 18.7911 57.1501 18.2304 55.7859 17.2026C55.4566 16.969 55.1744 16.6419 54.5158 16.0813C53.3398 14.96 52.7754 14.3994 52.1638 14.0256C49.6237 12.3904 46.3779 12.3904 43.8377 14.0256C43.2262 14.3994 42.6617 14.96 41.4857 16.0813Z",
    fill: "url(#paint2_linear_3_1246)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6556 54.5424C61.1577 48.7292 59.0046 42.9628 56.3366 37.2903C56.243 37.0559 56.0557 36.9152 55.8217 36.8215L47.0219 33.6336C46.6943 33.5398 46.6475 33.1179 46.9283 32.8835L48.707 31.5709C49.5495 30.9145 48.8474 29.555 47.8177 29.93L34.852 34.7587C34.1031 35.04 34.0095 36.1183 34.7584 36.4933L42.8561 40.5719C43.371 40.8532 43.5582 41.5564 43.1369 42.0252L35.1329 51.6358C34.9925 51.7764 34.852 51.8702 34.6648 51.917L26.2863 54.2611C25.4438 54.4955 25.3502 55.6206 26.1459 55.9957C40.4221 62.8871 61.5322 63.9654 72.0638 57.8709C72.8595 57.4021 72.5787 56.2301 71.6894 56.1363L63.4513 55.1987C63.0768 55.1987 62.7492 54.9174 62.6556 54.5424Z",
    fill: "url(#paint3_linear_3_1246)",
    stroke: "url(#paint4_linear_3_1246)",
    strokeWidth: 2.13333
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 0C56.1719 0 63.866 2.04372 70.6016 5.64551L24.3701 89.7871C9.81979 81.5414 0 65.9186 0 48C0 21.4903 21.4903 0 48 0Z",
    fill: "url(#paint5_linear_3_1246)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_1246",
    x1: 24.5333,
    y1: 4.26667,
    x2: 68.2667,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BDAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26918F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_1246",
    x1: 19.2,
    y1: 9.6,
    x2: 74.6667,
    y2: 88.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DC4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_1246",
    x1: 30.9341,
    y1: 18.1325,
    x2: 64.0008,
    y2: 85.3325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DC4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_1246",
    x1: 37.332,
    y1: 34.1324,
    x2: 57.5986,
    y2: 62.9324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABEDD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_1246",
    x1: 36.2653,
    y1: 29.8657,
    x2: 58.6653,
    y2: 62.9324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21B8AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_1246",
    x1: 36.2654,
    y1: -6.39977,
    x2: 36.2654,
    y2: 98.1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26918F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.e1868f0c130d8e6b27a1e4474210f114.svg";
export { ForwardRef as ReactComponent };